//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  setStockReminder(email:string, sku:string) {
    Dispatcher.dispatchAction(Constants.SET_STOCK_REMINDER, { email, sku });
  },
};
